import { render, staticRenderFns } from "./EditarUser.vue?vue&type=template&id=c5bc382a"
import script from "./EditarUser.vue?vue&type=script&lang=js"
export * from "./EditarUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports